'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var R = require('ramda');

/**
 * Unique identifier for a process.
 *
 * @typedef {string} ProcessId
 */

/**
 * @constant
 */

var UPDATED = 'processes/UPDATED';
/**
 * Updates processes.
 *
 * @param {ProcessId} id
 * @param {boolean} running
 * @returns {Object} Redux action
 * @private
 */

function update(id, running) {
  return {
    type: UPDATED,
    payload: {
      id: id,
      running: running
    }
  };
}

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case UPDATED:
      {
        return R.assocPath([action.payload.id], action.payload.running, state);
      }

    default:
      {
        return state;
      }
  }
}
/**
 * Starts tracking process.
 *
 * @param {ProcessId} process
 * @returns {Object} Redux action
 */

function start(process) {
  return update(process, true);
}
/**
 * Stops tracking process.
 *
 * @param {ProcessId} process
 * @returns {Object} Redux action
 */

function stop(process) {
  return update(process, false);
}
/**
 * Get process status from provided processes.
 *
 * @param {Object} state
 * @param {Object} props
 * @param {Array.<ProcessId>} props.ids List of process ids
 * @returns {Boolean} Returns true if any of the provided processes
 * are running else false if not found or no process was running
 */

function isRunning(state, props) {
  return R.any(function (id) {
    return R.pathOr(false, [id], state);
  }, props.ids);
}
/**
 * Get process status from all processes.
 *
 * @param {Object} state
 * @returns {Boolean} Returns true if any of the processes
 * are running else false if not found or no process was running
 */

function isAnyRunning(state) {
  return R.any(R.equals(true), R.values(state));
}

exports.UPDATED = UPDATED;
exports.reducer = reducer;
exports.start = start;
exports.stop = stop;
exports.isRunning = isRunning;
exports.isAnyRunning = isAnyRunning;
//# sourceMappingURL=index.js.map
